export default __webpack_public_path__ + "static/media/spirit-animal-logo.fca43c09.svg";